// extracted by mini-css-extract-plugin
export var slide = "Slide-module--slide--9415d";
export var img = "Slide-module--img--64af3";
export var text = "Slide-module--text--896b6";
export var pictureWrapper = "Slide-module--pictureWrapper--9085d";
export var picture = "Slide-module--picture--13d94";
export var subtitle = "Slide-module--subtitle--19d56";